import { trpc } from '@/shared/api/trpc';

export const useFlaggedCount = () => trpc.tasks.flaggedCount.useQuery();
